import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {NgbAccordionConfig, NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Phone, IPhone} from '../../shared/model/phone.model';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {NgxSpinnerService} from 'ngx-spinner';
import {Observable} from 'rxjs/Rx';
import {PhoneService} from '../phone/phone.service';
import {PhoneTypeService} from '../phone-type/phone-type.service';
import {IPhoneType} from '../../shared/model/phone-type.model';
import {Customer, ICustomer} from '../../shared/model/customer.model';
import {FormBuilder} from '@angular/forms';
import {CustomerService} from './customer.service';
import {TransactionService} from '../transaction/transaction.service';
import {FieldActivityService} from '../field-activity/field-activity.service';
import {ToastrService} from 'ngx-toastr';
import {ProjectService} from '../project/project.service';
import {EmployeeService} from '../../core/employee/employee.service';
import {JhiDataUtils} from 'ng-jhipster';
import {AccountService} from '../../singelton/account.service';
import {TranslateService} from '@ngx-translate/core';
import {IProject, Project} from '../../shared/model/project.model';
import {ITransaction, Transaction} from '../../shared/model/transaction.model';
import {IActionType} from '../../shared/model/action-type.model';
import {ActionTypeService} from '../action-type/action-type.service';
import {Employee, IEmployee} from '../../shared/model/employee.model';
import {Organization} from '../../shared/model/organization.model';
import {RapidCustomerService} from './rapid-customer.service';
import {IRapidCustomer, RapidCustomer} from '../../shared/model/rapid-customer.model';
import {IConnector} from "../../shared/model/connector.model";
import {ConnectorService} from "../connector/connector.service";
import {IPosition} from "../../shared/model/position.model";
import {PositionService} from "../position/position.service";
import {PositionUpdateComponent} from "../position/position-update.component";
import {IStateCity, StateCity} from "../../shared/model/stateCity.model";
import {IFieldActivity} from "../../shared/model/field-activity.model";
import {FieldActivityUpdateComponent} from "../field-activity/field-activity-update.component";
import {ConnectorUpdateComponent} from "../connector/connector-update.component";
import {PhoneTypeUpdateComponent} from "../phone-type/phone-type-update.component";
import {ActionTypeUpdateComponent} from "../action-type/action-type-update.component";
import {IStep} from "../../shared/model/step.model";
import {StepService} from "../step/step.service";
import {COMPANY_NAME} from "../../app.constants";

// import { JhiEventManager } from 'ng-jhipster';


@Component({
  selector: 'app-customer-add-rapid-dialog',
  templateUrl: './customer-add-rapid-project2.component.html',
  styleUrls: ['./customer-add-rapid.component.scss']
  // templateUrl: './customer-add-rapid.component.html'
})
export class CustomerAddRapidComponent implements OnInit {
  @Input() type;
  @Input() part;
  @Input() number;
  company_name= COMPANY_NAME;

  phones: IPhone[];
  positions: IPosition[];
  phoneTypes: IPhoneType[];
  phoneTypes2: IPhoneType[];
  actionTypes: IActionType[];
  connectors: IConnector[];
  fieldActivities: IFieldActivity[];
  transaction: ITransaction = new Transaction();
  employees: IEmployee[];
  steps: IStep[];

  rapidCustomer: IRapidCustomer = new RapidCustomer();
  customer: ICustomer = new Customer();
  project: IProject = new Project();

  isSaving: boolean;

  cityList: StateCity[];
  stateList: StateCity[];

  chekNeedReminder: Boolean = false;

  dateObject: any;
  dateObject2: any;

  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;

  showTypeOrgan = false;

  nextCustomerFormShow = false;
  @Input() phoneEdit;
  public serverValidationError = false;
  customers: ICustomer[];
  keyword = 'title';
showCustomerNewForm=false;
  selectEvent(item) {
    this.rapidCustomer.customer = new Customer(item.id);
    this.rapidCustomer.customer_id = (item.id);
  }

  onChangeSearch(val: string) {
    this.customer.title = val;
    this.searchCustomer(this.page);
  }

  onFocused(e) {
  }

  constructor(public activeModal: NgbActiveModal,
              public phoneTypeService: PhoneTypeService,
              protected customerService: CustomerService
    , private fb: FormBuilder,
              protected transactionService: TransactionService,
              protected activatedRoute: ActivatedRoute,
              protected fieldActivityService: FieldActivityService,
              protected connectorService: ConnectorService,
              private toastr: ToastrService,
              public projectService: ProjectService,
              public actionTypeService: ActionTypeService,
              private spinner: NgxSpinnerService,
              public employeeService: EmployeeService,
              protected dataUtils: JhiDataUtils,
              private modalService: NgbModal,
              protected phoneService: PhoneService,
              protected positionService: PositionService,
              protected accountService: AccountService,
              protected router: Router,
              private translate: TranslateService,
              protected rapidCustomerService: RapidCustomerService,
              public stepService: StepService,
              config: NgbAccordionConfig

              // protected eventManager: JhiEventManager
  ) {
    this.itemsPerPage = 20;
    this.page = 1;
    this.predicate = 'itemName';
    this.reverse = 'asc';
    // this.rapidCustomer.type = 'حقیقی';

  }

  ngOnInit() {

    this.loadAllPhoneTypes();
    this.loadAllPositions();
    // this.loadAllActionTypes();
    this.loadAllEmployee();
    this.loadAllConnector();
    this.getState();
    this.loadAllStep();
    this.loadAllFieldActivity();
if(this.part && this.part === 'callCenter') {
  this.nextCustomerFormShow=true;
  this.rapidCustomer.phone_number=this.number;
}
  }
  addNewCustomer(){
    this.showCustomerNewForm = true;
  }
  selectFromCustomer(){
    this.showCustomerNewForm = false;
  }

  loadAllStep() {
    this.stepService.query({
      page: this.page - 1,
      size: this.itemsPerPage,
      sort: ['score', 'asc']

    }).subscribe(
      (res: HttpResponse<IStep[]>) => {
        this.steps = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  loadAllEmployee() {
    this.employeeService.query().subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body;
        // this.loadAllActionTypes();
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  loadAllFieldActivity() {
    this.fieldActivityService.query({
      page: 0,
      size: 10000,
      sort: ['itemName', 'asc']

    }).subscribe(
      (res: HttpResponse<IFieldActivity[]>) => {
        this.fieldActivities = res.body;
        // alert(' fieldActivities ==' + this.fieldActivities);
        // alert(' fieldActivities ==' + this.fieldActivities.length);
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  addPosition() {


    const modalRef = this.modalService.open(PositionUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    // modalRef.componentInstance.type = 'Task';
    // modalRef.componentInstance.customerId = this.customer.id;

    modalRef.result.then(
      res => {
        this.loadAllPositions();
      },
      rejected => {
        this.loadAllPositions();
      }
    );

  }

  addConnector(content) {

    const modalRef = this.modalService.open(ConnectorUpdateComponent, {windowClass: 'lg', backdrop: 'static'});

    modalRef.result.then(
      res => {
        this.loadAllConnector();
      },
      rejected => {
        this.loadAllConnector();
      }
    );

  }

  addActionType(content) {

    const modalRef = this.modalService.open(ActionTypeUpdateComponent, {windowClass: 'lg', backdrop: 'static'});

    modalRef.result.then(
      res => {
        this.loadAllActionTypes();
      },
      rejected => {
        this.loadAllActionTypes();
      }
    );

  }


  addPhoneType() {


    const modalRef = this.modalService.open(PhoneTypeUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    // modalRef.componentInstance.type = 'Task';
    // modalRef.componentInstance.customerId = this.customer.id;

    modalRef.result.then(
      res => {
        this.loadAllPhoneTypes();
      },
      rejected => {
        this.loadAllPhoneTypes();
      }
    );

  }


  addFieldActivity(content) {


    const modalRef = this.modalService.open(FieldActivityUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    // modalRef.componentInstance.type = 'Task';
    // modalRef.componentInstance.customerId = this.customer.id;

    modalRef.result.then(
      res => {
        this.loadAllFieldActivity();
      },
      rejected => {
        this.loadAllFieldActivity();
      }
    );

  }

  protected onSaveSuccess() {
    // this.isSaving = false;
    this.activeModal.dismiss('cancel');
    // this.toastr.success('     ثبت با موفقیت انجام شد.      ', '   کاربر گرامی!    ');

    // this.previousState();
  }

  protected onSaveError() {
    // this.isSaving = false;
  }


  getCity() {
    const state = this.customer.state;
    this.customerService
      .getCities({
        page: 0,
        size: 500,
        state,
      })
      .subscribe(
        (res: HttpResponse<IStateCity[]>) => this.onSuccessCity(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  protected onSuccessCity(data: IStateCity[], headers: HttpHeaders) {
    this.cityList = data;
  }

  getState() {
    const state = this.customer.state;
    this.customerService
      .getStates({
        page: 0,
        size: 500,
        state,

      })
      .subscribe(
        (res: HttpResponse<IStateCity[]>) => this.onSuccessState(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  protected onSuccessState(data: IStateCity[], headers: HttpHeaders) {
    this.stateList = data;
    if (this.customer && this.customer != null && this.customer.state && this.customer.state != null) {
      this.getCity();
    }

  }


  goToProfile(id) {
    this.router.navigate(['/page/profile-customer-project/' + id + '/project']);
    this.clear();
  }

  nextToAdd() {
    this.loadAllPhoneTypes();
    this.loadAllPositions();

    this.nextCustomerFormShow = true;

  }

  loadAllPhoneTypes() {
    this.phoneTypeService.query({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort2(this.predicate, this.reverse)
      }
    ).subscribe(
      (res: HttpResponse<IPhoneType[]>) => {
        this.phoneTypes = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllPositions() {
    this.positionService.query({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort2(this.predicate, this.reverse)
      }
    ).subscribe(
      (res: HttpResponse<IPosition[]>) => {
        this.positions = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  sort2(predicate, reverse) {
    let result = ['itemName, asc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }

  edit() {
    this.phones = [];
    this.phones.length = 0;
    this.nextCustomerFormShow = false;
  }

  search(page) {
    const number = (this.rapidCustomer.phone_number ? String(this.rapidCustomer.phone_number).trim() : '');
    if (!number || number.length < 8) {
      this.toastr.warning('شماره تلفن را کامل وارد کنید (حداقل ۸ رقم)', 'توجه');
      return;
    }

    this.spinner.show();
    const temp = 'd';

    this.phoneService
      .search({
        page: 0,
        size: 20,
        sort: this.sort(),
        temp,
        number
      })
      .subscribe(
        (res: HttpResponse<IPhone[]>) => this.paginatePhones(res.body, res.headers),
        (res: HttpErrorResponse) => {
          this.spinner.hide();
          this.onError(res.message);
          this.toastr.error('خطا در جستجوی شماره تلفن', 'خطا');
        }
      );
  }

  onFormSubmit(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    // تا قبل از باز شدن فرم کامل، Enter نباید ذخیره بزند
    if (!this.nextCustomerFormShow && !(this.part && this.part === 'callCenter')) {
      this.search(1);
      return;
    }
    this.save();
  }

  trackId(index: number, item: IPhone) {
    return item && item.id != null ? item.id : index;
  }

  protected paginatePhones(data: IPhone[], headers: HttpHeaders) {

    this.phones = data || [];
    this.spinner.hide();

    if (this.phones && this.phones.length === 0) {
      this.nextToAdd();
    } else if (this.phones && this.phones.length > 0) {
      // نتایج پیدا شد؛ فرم جدید باز نشود
      this.nextCustomerFormShow = false;
    }

  }

  sort() {
    const result = ['audience, asc'];
    return result;
  }

  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }

  confirmDelete(id: number) {
    this.phoneService.delete(id).subscribe(response => {

      this.activeModal.dismiss(true);
    });
  }

  loadAllConnector() {
    this.connectorService.query({
      page: 0,
      size: 10000,
      sort: ['itemName', 'asc']

    }).subscribe(
      (res: HttpResponse<IConnector[]>) => {
        this.connectors = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  chekType() {
    if (this.rapidCustomer.customer_type === 'حقیقی') {
      this.showTypeOrgan = false;
    } else if (this.rapidCustomer.customer_type === 'حقوقی') {
      this.showTypeOrgan = true;

    }
  }

  loadAllActionTypes() {
    this.spinner.show();
    this.actionTypeService.queryByStep(this.rapidCustomer.step_number).subscribe(
      (res: HttpResponse<IActionType[]>) => {
        this.actionTypes = res.body;
        this.spinner.hide();
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  save() {
    let temp = '';
    if (this.rapidCustomer.customer_type && this.rapidCustomer.customer_type === 'حقیقی') {
      if (this.rapidCustomer.gender === 'Female') {
        temp = 'خانم ' + temp;
      } else if (this.rapidCustomer.gender_phone === 'Male') {
        temp = 'آقای ' + temp;
      }

      if (this.rapidCustomer.prefix) {
        temp = temp + this.rapidCustomer.prefix + ' ';
      }

      if (this.rapidCustomer.firstName) {
        temp = temp + this.rapidCustomer.firstName + ' ';
      }

      if (this.rapidCustomer.lastName) {
        temp = temp + this.rapidCustomer.lastName;
      }

      this.rapidCustomer.customer_title = temp;

      this.rapidCustomer.gender_phone = this.rapidCustomer.gender;
      this.rapidCustomer.prefix_phone = this.rapidCustomer.prefix;
      this.rapidCustomer.firstName_phone = this.rapidCustomer.firstName;
      this.rapidCustomer.lastName_phone = this.rapidCustomer.lastName;

      this.rapidCustomer.audience = temp;

    } else {
      if (this.rapidCustomer.gender_phone === 'Female') {
        temp = 'خانم ' + temp;
      } else if (this.rapidCustomer.gender_phone === 'Male') {

        temp = 'آقای ' + temp;
      }

      if (this.rapidCustomer.prefix_phone) {
        temp = temp + this.rapidCustomer.prefix_phone + ' ';
      }

      if (this.rapidCustomer.firstName_phone) {
        temp = temp + this.rapidCustomer.firstName_phone + ' ';
      }

      if (this.rapidCustomer.lastName_phone) {
        temp = temp + this.rapidCustomer.lastName_phone;
      }

      if (temp === '') {

        this.rapidCustomer.audience = this.rapidCustomer.customer_title;
        this.rapidCustomer.lastName_phone = this.rapidCustomer.customer_title;

      } else {

      }

    }


    this.rapidCustomer.cycle_type = this.type;
    if (this.nextCustomerFormShow) {

      this.spinner.show();
      this.isSaving = true;
      this.rapidCustomer.organization = new Organization(1);

      const span_followDate = document.getElementById('span_followDate');
      this.rapidCustomer.employee = new Employee(this.rapidCustomer.employee_str);
      this.rapidCustomer.customer = this.customer;

      this.rapidCustomer.organization = new Organization(1);

      const span_actionDate = document.getElementById('span_actionDate');
      if (span_actionDate) {
        this.rapidCustomer.jalaliDate = (<HTMLInputElement>span_actionDate).innerHTML;
      }


      const span_actionDate2 = document.getElementById('span_actionDate2');
      if (span_actionDate2) {
        this.rapidCustomer.jalaliDate = (<HTMLInputElement>span_actionDate2).innerHTML;
      }

      if (span_followDate) {
        this.rapidCustomer.jalaliDateFollow = (<HTMLInputElement>span_followDate).innerHTML;
      }


      this.rapidCustomer.status = 'In_progress';
      this.rapidCustomer.type = 'Follow';
      this.subscribeToSaveResponseRapid(this.rapidCustomerService.create(this.rapidCustomer));
    }
  }

  protected subscribeToSaveResponseRapid(result: Observable<HttpResponse<IRapidCustomer>>) {
    result.subscribe((res: HttpResponse<IRapidCustomer>) => this.onSaveSuccessRapid(res), (res: HttpErrorResponse) => this.onSaveError());
  }

  // protected subscribeToSaveResponse(result: Observable<HttpResponse<ICustomer>>) {
  //   result.subscribe((res: HttpResponse<ICustomer>) => this.onSaveSuccessCustomer(res), (res: HttpErrorResponse) => this.onSaveError());
  // }

  // protected onSaveSuccessCustomer(res) {
  //   this.customer = res.body;
  //   this.isSaving = false;
  //   this.toastr.success('     ثبت با موفقیت انجام شد.      ', '   کاربر گرامی!    ');
  //   this.spinner.hide();
  //   this.savePhone(this.customer);
  // }

  protected onSaveSuccessRapid(res) {

    this.rapidCustomer = res.body;

    this.isSaving = false;
    this.toastr.success('     ثبت با موفقیت انجام شد.      ', '   کاربر گرامی!    ');
    this.spinner.hide();
    this.clear();
    // if (this.type === 'project') {
    this.router.navigate(['/page/profile-customer-project/' + this.rapidCustomer.customer.id + '/project']);
    if (this.type === 'sales') {
      this.router.navigate(['/page/profile-customer-project/' + this.rapidCustomer.customer.id + '/salesCycle']);

    } else {
      this.router.navigate(['/page/profile-customer/' + this.rapidCustomer.customer.id ]);

    }
  }



  searchCustomer(page) {

    if (page) {
      this.page = page;
    } else {
      this.page = 1;

    }

    this.spinner.show();

    const title = (this.customer.title ? this.customer.title : '');

    this.customerService
      .searchAnutocomplete({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: ['title,asc'],
        title

      })
      .subscribe(
        (res: HttpResponse<ICustomer[]>) => this.paginateCustomers(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }
  protected paginateCustomers(data: ICustomer[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.customers = data;
    this.spinner.hide();
  }
  // savePhone(customer) {
  //   this.isSaving = true;
  //   this.phone.customer = customer;
  //   this.subscribeToSaveResponsePhone(this.phoneService.create(this.phone));
  // }
  //
  // protected subscribeToSaveResponsePhone(result: Observable<HttpResponse<IPhone>>) {
  //   result.subscribe((res: HttpResponse<IPhone>) => this.onSaveSuccessPhone(res), (res: HttpErrorResponse) => this.onSaveError());
  // }
  //
  // protected onSaveSuccessPhone(res) {
  //   this.phone = res;
  //   this.isSaving = false;
  //   this.saverProject(this.customer);
  // }
  // saverProject(customer) {
  //   this.isSaving = true;
  //   if (customer) {
  //     this.project.customer = customer;
  //   }
  //   this.subscribeToSaveResponsePrj(this.projectService.create(this.project));
  // }
  //
  // protected subscribeToSaveResponsePrj(result: Observable<HttpResponse<IProject>>) {
  //
  //   result.subscribe((res: HttpResponse<IProject>) => this.onSaveSuccessPrj(res), (res: HttpErrorResponse) => this.onSaveError());
  // }
  //
  // protected onSaveSuccessPrj(res) {
  //   this.project = res;
  //   this.isSaving = false;
  //   this.saveTransaction(this.project);
  // }
  //
  //
  //
  // saveTransaction(project) {
  //   this.isSaving = true;
  //   const span_followDate = document.getElementById('span_followDate');
  //   this.transaction.employee = new Employee(this.transaction.employee_str);
  //   // this.transaction.project = this.project;
  //   this.transaction.customer = this.customer;
  //
  //   this.transaction.organization = new Organization(1);
  //
  //   const span_actionDate = document.getElementById('span_actionDate');
  //   if (span_actionDate) {
  //     this.transaction.jalaliDate = (<HTMLInputElement>span_actionDate).innerHTML;
  //   }
  //
  //
  //   const span_actionDate2 = document.getElementById('span_actionDate2');
  //   if (span_actionDate2) {
  //     this.transaction.jalaliDate = (<HTMLInputElement>span_actionDate2).innerHTML;
  //   }
  //
  //   if (span_followDate) {
  //     this.transaction.jalaliDateFollow = (<HTMLInputElement>span_followDate).innerHTML;
  //   }
  //
  //
  //   this.transaction.status = 'In_progress';
  //   this.transaction.type = 'Follow';
  //
  //
  //   this.subscribeToSaveResponseTr(this.transactionService.create(this.transaction));
  //
  //
  // }
  //
  // protected subscribeToSaveResponseTr(result: Observable<HttpResponse<ITransaction>>) {
  //   result.subscribe((res: HttpResponse<ITransaction>) => this.onSaveSuccessTr(res.body), (res: HttpErrorResponse) => this.onSaveError());
  // }
  //
  //
  // protected onSaveSuccessTr(res) {
  //   this.transaction = res;
  //   this.isSaving = false;
  // }

}
